class CartGiftWrap extends HTMLElement {
  constructor() {
    super();

    this.product = JSON.parse(this.querySelector("[data-json]").textContent);
    this.priceEl = this.querySelector(".js-price");
    this.input = this.querySelector(".js-input");
    this.validating = false;
  }

  connectedCallback() {
    this.input.addEventListener("input", this.onInputChange.bind(this));
  }

  async getCart() {
    return fetch(`${theme.routes.cart_url}.js`, {
      credentials: "same-origin",
      method: "GET",
    }).then((response) => response.json());
  }

  async changeItem(key, qty) {
    return this._updateCart({
      url: ""
        .concat(`${theme.routes.cart_change_url}.js`, "?t=")
        .concat(Date.now()),
      data: JSON.stringify({
        id: key,
        quantity: qty,
      }),
    });
  }

  async refreshCart() {
    document.querySelector("cart-items").getCart();
  }

  async _updateCart(params) {
    return fetch(params.url, {
      method: "POST",
      body: params.data,
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
    })
      .then((response) => response.json())
      .then(function (cart) {
        return cart;
      });
  }

  async checkGiftWrap(checked = true) {
    // To avoid multipe functions running
    if (this.validating) return;
    this.validating = true;

    let cart = await this.getCart();

    const cartLine = cart.items.find(
      (item) => !!item.properties?._is_gift_wrap
    );
    const variant = this.product.variants[0];

    if (checked && !cartLine) {
      await this._updateCart({
        url: "/cart/add.js",
        data: JSON.stringify({
          items: [
            {
              id: variant.id,
              quantity: 1,
              properties: {
                _is_gift_wrap: true,
              },
            },
          ],
        }),
      });

      this.validating = false;

      this.refreshCart();
    }

    if (!checked && !!cartLine) {
      await this.changeItem(cartLine.key, 0);

      this.validating = false;
      this.refreshCart();
    }
  }

  onInputChange(e) {
    const checked = e.target.checked;

    this.checkGiftWrap(checked);
  }
}

customElements.define("cart-gift-wrap", CartGiftWrap);
